module.exports = __webpack_public_path__ + "static/media/back-1020.a4c61a24.jpg";